export default __webpack_public_path__ + "static/media/sin soja.dd8fab1f.svg";